import type * as React from "react"
import { cn } from "@/lib/utils"

/** Card section of the agent editor: icon + title/description header, content below. */
export function EditorSection({
  icon: Icon,
  title,
  description,
  actions,
  children,
  className,
  id,
}: {
  icon?: React.ComponentType<{ className?: string }>
  title: React.ReactNode
  description?: React.ReactNode
  actions?: React.ReactNode
  children: React.ReactNode
  className?: string
  id?: string
}) {
  return (
    <section id={id} className={cn("bg-card scroll-mt-20 rounded-xl border", className)}>
      <header className="flex items-start justify-between gap-3 border-b px-4 py-3 sm:px-5">
        <div className="flex min-w-0 items-start gap-2.5">
          {Icon && <Icon className="text-muted-foreground mt-0.5 size-4 shrink-0" />}
          <div className="min-w-0">
            <h2 className="text-sm font-semibold">{title}</h2>
            {description && <p className="text-muted-foreground mt-0.5 text-xs text-pretty">{description}</p>}
          </div>
        </div>
        {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
      </header>
      <div className="grid gap-5 p-4 sm:p-5">{children}</div>
    </section>
  )
}
